var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.valueModel,
          expression: "valueModel"
        }
      ],
      staticClass: "form-control",
      on: {
        change: function($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function(o) {
              return o.selected
            })
            .map(function(o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.valueModel = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        }
      }
    },
    [
      _c("option", [
        _vm._v(
          _vm._s(_vm.resource("JourneyBuilder_JourneyDropdown_PlaceholderText"))
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.journeys, function(journey) {
        return [
          _c(
            "option",
            _vm._b(
              {},
              "option",
              _vm.getJourneyOptionAttributes(journey),
              false
            ),
            [_vm._v("\n            " + _vm._s(journey.name) + "\n        ")]
          ),
          _vm._v(" "),
          journey.children.length
            ? _c(
                "optgroup",
                { attrs: { label: journey.name } },
                [
                  _vm._l(journey.children, function(subJourney) {
                    return [
                      _c(
                        "option",
                        _vm._b(
                          {},
                          "option",
                          _vm.getJourneyOptionAttributes(subJourney),
                          false
                        ),
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(subJourney.name) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }